<template>
  <a-modal
    title="请选择候选人没兴趣的原因"
    okText="保存"
    @ok="save"
    v-model="visible"
    :width="900"
  >
    <div>
      <a-radio-group @change="onChange" v-model="value">
        <a-radio :style="radioStyle" :value="1">有兴趣</a-radio>
        <a-radio :style="radioStyle" :value="2">没兴趣</a-radio>
      </a-radio-group>
    </div>
    <div v-if="showModel == true">
      <div>
        <div>
          <a-checkbox-group @change="onChangeCheck" v-model="defaltCheck">
            <a-row>
              <a-col :span="12" v-for="(item, index) in options" :key="index">
                <a-checkbox :value="item.id">
                  {{ item.text }}
                  <span
                    class="red"
                    v-if="item.id === '1' || item.id === '2' || item.id === '4'"
                    >（联动关系）</span
                  >
                </a-checkbox>
                <div
                  v-if="
                    (item.id === '1' && checkedValues.indexOf('1') !== -1) ||
                      (item.id === '2' && checkedValues.indexOf('2') !== -1) ||
                      (item.id === '4' && checkedValues.indexOf('4') !== -1)
                  "
                >
                  <a-input
                    v-if="item.show"
                    ref="input"
                    type="text"
                    size="small"
                    :style="{
                      display: 'block',
                      width: '120px',
                      marginTop: '10px',
                      marginBottom: '10px',
                      height: '25px',
                      lineHeight: '25px'
                    }"
                    :value="inputValue"
                    @change="handleInputChange"
                    @blur="handleInputConfirm(item)"
                    @keyup.enter="handleInputConfirm(item)"
                  />

                  <a-tag
                    v-else
                    @click="showInput(item)"
                    style="marginTop: 10px;marginBottom: 10px;background: #fff; borderStyle: dashed; display: block;width: 150px; height: 25px;lineHeight: 25px;"
                  >
                    <a-icon type="plus" />
                    <span v-if="item.id == '1'">候选人只看企业:</span>
                    <span v-if="item.id == '2'">候选人只看行业:</span>
                    <span v-if="item.id == '4'">候选人要求最少月薪(k):</span>
                  </a-tag>

                  <span v-for="(tag, index) in item.tags" :key="index">
                    <a-tooltip
                      v-if="tag && tag.length > 20"
                      :key="tag"
                      :title="tag"
                      class="tags"
                    >
                      <a-tag
                        :key="tag"
                        :closable="index !== -1"
                        :afterClose="() => handleClose(item, tag)"
                        >{{ `${tag.slice(0, 20)}...` }}</a-tag
                      >
                    </a-tooltip>
                    <a-tag
                      v-else
                      :closable="index !== -1"
                      :afterClose="() => handleClose(item, tag)"
                      :key="tag"
                      >{{ tag }}</a-tag
                    >
                  </span>
                </div>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <a-checkbox @change="onChangeOther">其他</a-checkbox>
          <input
            ref="addinput"
            type="text"
            class="add-input"
            v-show="showOther"
          />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "EditMessage",
  props: ["getListData"],
  created() {},
  mounted() {},
  watch: {
    value(val) {
      console.log(val);
      if (val == 2) {
        this.showModel = true;
      } else {
        this.showModel = false;
      }
    }
  },
  data() {
    return {
      id: undefined,
      post_id: undefined,
      resume_id: undefined,
      form: this.$form.createForm(this),
      type: "",
      record: "",
      visible: false,
      value: 0,
      defaltCheck: [],
      options: [],
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      tags: [],
      tagA: [],
      tagB: [],
      tagC: [],
      inputVisible: false,
      inputValue: "",
      showModel: false,
      checkedValues: [],
      addOrUpdate: 0,
      otherReason: "",
      showOther: false
    };
  },
  methods: {
    async getNotInterest() {
      this.defaltCheck = [];
      let response = await Api.hunterorder.getLatest({ post_id: this.post_id });
      if (response.item && response.item.type) {
        this.addOrUpdate = 1;
        let list = JSON.parse(JSON.stringify(response.item));
        this.id = list.id;
        this.value = Number(list.type);
        this.defaltCheck = list.not_interested_reasons;
        this.checkedValues = list.not_interested_reasons;
        let tagA = [];
        list.expected_companies.map(item => {
          tagA.push(item.name);
        });
        list.not_interested_reasons.map(arr => {
          if (arr == "1") {
            this.options[0].tags = tagA;
          } else if (arr == "2") {
            this.options[1].tags = list.expected_industries;
          } else if (arr == "4") {
            this.options[3].tags[0] = list.expected_monthly_salary;
          }
        });
      } else {
        this.addOrUpdate = 2;
        this.value = 0;
        this.defaltCheck = [];
      }
    },
    async getAllNotInterest() {
      this.defaltCheck = [];
      let res = await Api.hunterorder.getNotInterest();
      res.list.map(item => {
        item.show = false;
        item.tags = [];
      });
      this.options = res.list;
    },

    async save() {
      if (this.addOrUpdate == 1) {
        let params = {
          id: this.id,
          resume_id: this.resume_id,
          type: this.value,
          not_interested_reasons: JSON.stringify(this.checkedValues),
          expected_companies: JSON.stringify(this.tagA),
          expected_industries: JSON.stringify(this.tagB),
          expected_monthly_salary: this.tagC,
          other_reasons: this.otherReason
        };
        let res = await Api.hunterorder.editNoInterest(params);
        if (res) {
          this.$message.success(" 编辑成功");
          this.visible = false;
          this.getListData();
        } else {
          this.$message.error("编辑失败");
          this.visible = false;
        }
      } else if (this.addOrUpdate == 2) {
        let params = {
          post_id: this.post_id,
          resume_id: this.resume_id,
          type: this.value,
          not_interested_reasons: JSON.stringify(this.checkedValues),
          expected_companies: JSON.stringify(this.tagA),
          expected_industries: JSON.stringify(this.tagB),
          expected_monthly_salary: this.tagC,
          other_reasons: this.otherReason
        };
        let res = await Api.hunterorder.addNoInterest(params);
        if (res) {
          this.$message.success("添加成功");
          this.visible = false;
          this.getListData();
        } else {
          this.$message.error("添加失败");
          this.visible = false;
        }
      }
    },

    async show(item) {
      this.post_id = item.id;
      this.resume_id = item.resume_id;
      this.visible = true;
      this.getAllNotInterest();
      this.getNotInterest();
      if (this.type === "edit") {
        this.$nextTick().then(() => {
          this.form.setFieldsValue({
            //   company: this.record.title
          });
        });
      }
    },
    onChange(e) {
      console.log("radio checked", e.target.value);
      this.value = e.target.value;
    },
    onChangeCheck(checkedValues) {
      console.log("checked = ", checkedValues);
      this.checkedValues = checkedValues;
      console.log(this.checkedValues);
    },
    close() {
      this.visible = false;
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    showInput(item) {
      console.log(item);
      this.inputValue = "";
      item.show = true;
    },

    handleClose(item, removedTag) {
      console.log(JSON.stringify(item.tags));
      let res = [];

      switch (item.id) {
        case "1":
          item.tags = item.tags.filter(tag => tag !== removedTag);
          item.tags.map(eve => {
            res.push({ name: `${eve}` });
          });
          this.tagA = res;
          break;
        case "2":
          item.tags = item.tags.filter(tag => tag !== removedTag);
          this.tagB = item.tags;
          break;
        case "4":
          item.tags = item.tags.filter(tag => tag !== removedTag);
          this.tagC = "";
          break;
      }
      console.log(this.tagA, this.tagB, this.tagC);
    },

    handleInputConfirm(item) {
      item.show = false;
      const inputValue = this.inputValue;
      if (item.id != 4) {
        if (inputValue && item.tags.indexOf(inputValue) === -1) {
          item.tags = [...item.tags, inputValue];
        }
      } else {
        item.tags = [];
        item.tags[0] = inputValue;
      }

      if (item.id == 1) {
        let tagAll = [];
        item.tags.map(eve => {
          tagAll.push({ name: `${eve}` });
        });
        this.tagA = tagAll;
      } else if (item.id == 2) {
        this.tagB = item.tags;
      } else if (item.id == 4) {
        if (item.tags[0]) {
          this.tagC = item.tags[0];
        } else {
          this.tagC = "";
        }
      }
    },
    onChangeOther(e) {
      console.log(this.$refs.addinput.value);
      if (e.target.checked == true) {
        this.showOther = true;
        this.otherReason = this.$refs.addinput.value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.tags {
  .ant-tag {
    display: inline-block;
    width: 50px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.add-input {
  border: none;
  border-bottom: 1px solid rgba(220, 223, 230, 1);
  width: 300px;
  outline: none;
  margin-left: 10px;
  font-size: 14px;
}
</style>
